import React from "react";
import { Container, Col, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <Container className="mt-5">
      <Row>
        <Col xs="12" className="text-center">
          <h3>Seleccionar Tienda:</h3>
        </Col>
      </Row>
      <Row className="pt-3">
        <Col xs="4">
          <Link to={`/falabella`}>
            <Button className="w-100 border py-3 px-4 text-center"><b>Falabella</b></Button>
          </Link>
        </Col>
        <Col xs="4">
          <Link to={`/paris`}>
            <Button className="w-100 border py-3 px-4 text-center"><b>Paris</b></Button>
          </Link>
        </Col>
        <Col xs="4">
          <Link to={`/ripley`}>
            <Button className="w-100 border py-3 px-4 text-center"><b>Ripley</b></Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Index;
